import { render, staticRenderFns } from "./userFans.vue?vue&type=template&id=6c006654&scoped=true&"
import script from "./userFans.vue?vue&type=script&lang=js&"
export * from "./userFans.vue?vue&type=script&lang=js&"
import style0 from "./userFans.vue?vue&type=style&index=0&id=6c006654&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c006654",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\demoAdmin\\chuangyueBlockchaimAdmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c006654')) {
      api.createRecord('6c006654', component.options)
    } else {
      api.reload('6c006654', component.options)
    }
    module.hot.accept("./userFans.vue?vue&type=template&id=6c006654&scoped=true&", function () {
      api.rerender('6c006654', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/users/userControl/components/userFans.vue"
export default component.exports